var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-label"},[_c('label',{staticClass:"input-label__label",attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))]),(_vm.required)?_c('span',{staticClass:"input-label__required"},[_vm._v("Requis")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }